import { queryOptions, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { GenerateReportInput, Report } from "@tunic/shared";
import { api } from "./client";
import { qk } from "./keys";

export const reportsQuery = queryOptions({ queryKey: qk.reports.list, queryFn: () => api.get<Report[]>("/api/reports") });
export const reportQuery = (id: string) => queryOptions({ queryKey: qk.reports.detail(id), queryFn: () => api.get<Report>(`/api/reports/${id}`) });
export const useReports = () => useQuery(reportsQuery);
export const useReport = (id: string) => useQuery(reportQuery(id));

export function useReportActions() {
  const qc = useQueryClient();
  const generate = useMutation({
    mutationFn: (input: GenerateReportInput) => api.post<Report>("/api/reports/generate", input),
    onSuccess: () => qc.invalidateQueries({ queryKey: qk.reports.list }),
  });
  const markRead = useMutation({
    mutationFn: (id: string) => api.post(`/api/reports/${id}/read`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.reports.list });
      qc.invalidateQueries({ queryKey: qk.now });
    },
  });
  return { generate, markRead };
}
